import { supabase } from './supabaseClient';

export async function generateEquipment(leadId: string, quoteId?: string) {
  const { data, error } = await supabase.rpc('admin_generate_equipment', { p_lead: leadId, p_quote: quoteId || null });
  if (error) throw new Error(error.message);
  return data;
}

export async function confirmEquipment(shiftId: string, revision: number, equipment: string[], requestId = crypto.randomUUID()) {
  const { data, error } = await supabase.rpc('confirm_shift_equipment', {
    p_shift: shiftId, p_expected_revision: revision, p_request_id: requestId,
    p_equipment_list: equipment, p_equipment_manager: null,
  });
  if (error) throw new Error(error.message);
  return data;
}

export async function readEquipmentWorkspace(leadId: string) {
  const {data,error} = await supabase.rpc('admin_equipment_workspace',{p_lead:leadId});
  if(error) throw new Error(error.message);
  return data;
}

export async function readLegacyEquipmentResolution(leadId: string) {
  const {data,error}=await supabase.rpc('admin_legacy_equipment_resolution',{p_lead:leadId});
  if(error) throw new Error(error.message);
  return data;
}
export type LegacyResolutionDecision={task_id:string;action:'link'|'retain';shift_id:string|null;purpose:'PREP'|'RETURN'|null;reason:string;conflicts_ack:boolean};
export async function resolveLegacyEquipment(leadId:string,token:string,requestId:string,plan:LegacyResolutionDecision[]) {
  const {data,error}=await supabase.rpc('admin_resolve_legacy_equipment',{
    p_lead:leadId,p_token:token,p_request_id:requestId,p_plan:plan,p_reviewed:true,
  });
  if(error) throw new Error(error.message);
  return data;
}

export type EquipmentRefreshSource = 'saved_quote' | 'current_inventory';
export type EquipmentRefreshPreview = {equipment:string[]; warnings:string[]; source:EquipmentRefreshSource; quote_id:string; baseline_token:string};
export async function previewEquipmentRefresh(shiftId:string,quoteId:string,source:EquipmentRefreshSource):Promise<EquipmentRefreshPreview> {
  const {data,error}=await supabase.rpc('admin_preview_equipment_refresh',{p_shift:shiftId,p_quote:quoteId,p_source:source});
  if(error) throw new Error(error.message);
  return data;
}
export async function applyEquipmentRefresh(shiftId:string,preview:EquipmentRefreshPreview,equipment:string[]) {
  const {data,error}=await supabase.rpc('admin_apply_equipment_refresh',{
    p_shift:shiftId,p_quote:preview.quote_id,p_source:preview.source,p_baseline_token:preview.baseline_token,p_equipment:equipment,
  });
  if(error) throw new Error(error.message);
  return data;
}
